import { useIntl } from "react-intl";

const AppsAndIntegrations = () => {
    const intl = useIntl();
    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AppsAndIntegrations.header",
            defaultMessage: "Apps and integrations"
        }),
        body: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.AppsAndIntegrations.body",
                defaultMessage:
                    "Rich APIs and <apps>1,000 Marketplace apps</apps> let your IT team choose how they want to work."
            },

            {
                apps: (chunk: React.ReactNode) => (
                    <a
                        href="https://marketplace.atlassian.com/addons/app/jira-service-desk"
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="1,000 Marketplace apps"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default AppsAndIntegrations;
